import React, { useState } from "react";
import { Button, Popover, List, Skeleton } from 'antd';
import { DeleteOutlined, EyeOutlined } from "@ant-design/icons";
import RequestHandler from "util/RequestHandler";
import { Link, useHistory } from "react-router-dom";

const NotificationItem = ({ notification, dataIndex, onMarkAsReadSuccess, onDeleteSuccess, onClickNotificationWithBody, setPopoverVisible }) => {
  const [loading, setLoading] = useState(false);
  const { title, shortDescription, url } = notification;
  let history = useHistory();

  const onClickMarkAsRead = (id) => {
    setLoading(true);
    RequestHandler.put(`/FeatureNotification/MarkAsRead/${id}`, null, false).then((response) => {
      setLoading(false);
      if (response.success) {
        onMarkAsReadSuccess(id, dataIndex);
      }
    });
  };

  const onClickDelete = (id) => {
    setLoading(true);
    RequestHandler.delete(`/FeatureNotification/${id}`, null, false).then((response) => {
      setLoading(false);
      if (response.success) {
        onDeleteSuccess(id, dataIndex);
      }
    });
  };

  const onClickExtarnalUrlTitle = () => {
    if (!notification.isRead) {
      onClickMarkAsRead(notification.id);
    }
  };

  const onClickUrlTitle = () => {
    if (!notification.isRead) {
      onClickMarkAsRead(notification.id);
    }

    if (setPopoverVisible) {
      setPopoverVisible(false);
    }
  };

  const onClickContentTitle = () => {
    if (!notification.isRead) {
      onClickMarkAsRead(notification.id);
    }

    if (onClickNotificationWithBody) {
      onClickNotificationWithBody(notification.id);
    }

    if (setPopoverVisible) {
      setPopoverVisible(false);
    }
  };

  const onClickListItemMeta = () => {
    if (!notification.isRead) {
      onClickMarkAsRead(notification.id);
    }

    if (url) {
      const isExternalUrl = url.toLowerCase().startsWith("http");
      return isExternalUrl ? window.open(url, '_blank', 'noopener,noreferrer') : history.push(url);
    }

    if (notification.hasContentBody) {
      onClickContentTitle();
    }

    if (setPopoverVisible) {
      setPopoverVisible(false);
    }
  };

  const renderTitle = () => {
    if (url) {
      const isExternalUrl = url.toLowerCase().startsWith("http");
      return isExternalUrl ?
        (<a href={url} target="_blank" rel="noreferrer" onClick={onClickExtarnalUrlTitle}>{title}</a>) :
        (<Link to={url} onClick={onClickUrlTitle}>{title}</Link>);
    }

    if (notification.hasContentBody) {
      return (<a className="gx-link gx-font-weight-semi-bold" onClick={onClickContentTitle}>{title}</a>)
    }

    return title;
  };

  const getActions = () => {
    if (loading) {
      return (
        <Button type="text" loading={loading} style={{ border: 0 }} />
      );
    }

    return (
      <>
        {!notification.isRead && (
          <Popover content="Okundu Olarak İşaretle">
            <Button className="gx-mb-0" type="text" icon={<EyeOutlined />} onClick={() => onClickMarkAsRead(notification.id)} />
          </Popover>
        )
        }
        <Popover content="Sil">
          <Button className="gx-mb-0" type="text" icon={<DeleteOutlined />} onClick={() => onClickDelete(notification.id)} />
        </Popover>
      </>
    );
  }

  return (
    <List.Item style={{ padding: "12px 16px", backgroundColor: notification.isRead ? undefined : "rgba(51, 108, 213, 0.2)" }} >
      <Skeleton loading={false}>
        <List.Item.Meta
          title={<strong>{renderTitle()}</strong>}
          description={shortDescription}
          onClick={url || notification.hasContentBody ? onClickListItemMeta : undefined}
          style={{ cursor: url || notification.hasContentBody ? "pointer" : undefined }}
        />
        <div>{getActions()}</div>
      </Skeleton>
    </List.Item >
  );
};

export default NotificationItem;